import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormGroup from '@mui/material/FormGroup';
import React, { useState } from 'react';
import styled from 'styled-components';
import Button from 'components/input/Button';
import { AdminSystemLocaleDto } from 'services/data-contracts';
import { useStoreWrapper } from 'stores/StoreHelper';

const LocaleLists = ({
  languages,
  onChange,
}: {
  languages: AdminSystemLocaleDto[];
  onChange: (languages: AdminSystemLocaleDto[]) => void;
}) => {
  const { uiStore } = useStoreWrapper();

  const [selectedLanguages, setSelectedLanguages] = useState<AdminSystemLocaleDto[]>([]);

  const handleCheckboxChange = (locale: AdminSystemLocaleDto, checked: boolean) => {
    if (checked) {
      const isAlreadySelected = selectedLanguages.some((lang) => lang.id === locale.id);
      if (!isAlreadySelected) {
        setSelectedLanguages([...selectedLanguages, { ...locale, isActive: checked }]);
      }
    } else {
      setSelectedLanguages(selectedLanguages.filter((language) => language.id !== locale.id));
    }
  };

  return (
    <Container>
      <div style={{ padding: '0px 40px', flexGrow: 1, overflowY: 'scroll' }}>
        <div style={{ marginBottom: '20px' }}>추가된 언어의 일괄 삭제는 지원하지 않습니다.</div>
        <FormGroup>
          {languages?.map((locale) => (
            <div key={locale.id} style={{ marginBottom: '15px' }}>
              <FormControlLabel
                control={
                  <Checkbox
                    disabled={locale.isActive}
                    defaultChecked={locale.isActive}
                    onChange={(e) => handleCheckboxChange(locale, e.target.checked)}
                  />
                }
                label={`${locale.name} (${locale.locale})`}
              />
            </div>
          ))}
        </FormGroup>
      </div>
      <div style={{ position: 'sticky', background: 'white', bottom: 0, padding: '20px 40px' }}>
        <Button
          style={{ width: '300px' }}
          onClick={() => {
            onChange(selectedLanguages);
            uiStore?.drawer.close();
          }}
        >
          적용
        </Button>
      </div>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
`;
export default LocaleLists;
